import { notification } from 'antd';

import i18n from '../settings/i18n/i18n';
import { notificationPlacement, notificationDuration } from '../constants/notification';

export const openNotification = (
  type,
  title,
  asTranslationKey = true,
  placement = notificationPlacement.topRight,
  duration = notificationDuration,
) =>
  notification[type]({
    message: asTranslationKey ? i18n.t(title) : title,
    placement: placement,
    duration: duration,
  });
